import api from '../lib/api';

const agentService = {
    getAgents: async () => {
        try {
            const response = await api.get('/agents');
            return response.data;
        } catch (error) {
            console.error('Error fetching agents:', error);
            throw error;
        }
    },

    getAgent: async (id) => {
        try {
            const response = await api.get(`/agents/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching agent:', error);
            throw error;
        }
    },

    createAgent: async (agentData) => {
        try {
            const formData = new FormData();
            
            Object.keys(agentData).forEach(key => {
                if (key === 'photo') {
                    if (agentData[key] instanceof File) {
                        formData.append(key, agentData[key]);
                    }
                } else if (key === 'languages_spoken') {
                    if (agentData[key] && Array.isArray(agentData[key]) && agentData[key].length > 0) {
                        agentData[key].forEach((lang) => {
                            if (lang && lang.trim() !== '') {
                                formData.append('languages_spoken[]', lang.trim());
                            }
                        });
                    }
                } else {
                    const value = agentData[key];
                    if (value !== null && value !== undefined) {
                        formData.append(key, value === '' ? '' : value);
                    }
                }
            });

            const response = await api.post('/agents', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error creating agent:', error);
            throw error;
        }
    },

    updateAgent: async (id, agentData) => {
        try {
            const formData = new FormData();
            
            Object.keys(agentData).forEach(key => {
                if (key === 'photo') {
                    if (agentData[key] instanceof File) {
                        formData.append(key, agentData[key]);
                    }
                } else if (key === 'remove_photo') {
                    // Handle boolean for photo removal
                    formData.append(key, agentData[key] ? '1' : '0');
                } else if (key === 'languages_spoken') {
                    if (agentData[key] && Array.isArray(agentData[key]) && agentData[key].length > 0) {
                        agentData[key].forEach((lang) => {
                            if (lang && lang.trim() !== '') {
                                formData.append('languages_spoken[]', lang.trim());
                            }
                        });
                    }
                } else {
                    const value = agentData[key];
                    if (value !== null && value !== undefined) {
                        formData.append(key, value === '' ? '' : value);
                    }
                }
            });

            const response = await api.post(`/agents/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error updating agent:', error);
            throw error;
        }
    },

    deleteAgent: async (id) => {
        try {
            const response = await api.delete(`/agents/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting agent:', error);
            throw error;
        }
    },
};

export default agentService;

